<template>
  <div class="form-page">
    <div class="text-white text-center pt-5">
      <h2>Sign up</h2>
      <p>
        Already have an account?
        <router-link to="/login" class="text-warning ms-3">Login</router-link>
      </p>
    </div>
    <form
      @submit.prevent="handleSubmit"
      class="log-sign-form d-flex flex-column bg-white text-dark"
    >
      <label for="email" class="mb-1 text-warning">Email:</label>
      <input
        type="email"
        name="email"
        v-model="email"
        required
        placeholder="Email address"
        class="mb-3 p-2"
      />

      <label for="password" class="mb-1 text-warning">Password:</label>
      <input
        type="password"
        name="password"
        v-model="password"
        required
        placeholder="Password"
        class="mb-3 p-2"
      />

      <button class="btn btn-warning mb-3">Sign up</button>
      <div v-if="error" class="error mt-2 text-center">
        <span class="text-danger mb-1">{{ error }}</span>
      </div>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import useSignup from "../composables/useSignup";
export default {
  setup() {
    const email = ref("");
    const password = ref("");

    const { signup, error } = useSignup();
    const router = useRouter();

    const handleSubmit = async () => {
      await signup(email.value, password.value);
      if (!error.value) {
        router.push("/");
      }
    };

    return { email, password, handleSubmit, error };
  },
};
</script>
